import { ReactComponent as UsersDark } from "./users-dark-icon.svg";

const UsersDarkIcon: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
> = (props) => <UsersDark {...props} />;

export default UsersDarkIcon;
